export default {"viewBox":"0 0 20 20","body":"<path d=\"M15 12l-5-5-5 5z\" />"};